import React, { useEffect } from "react"

import { useTranslation } from "react-i18next"
import CRUD from "../core/genericCRUD/CRUD"
import { parsedUser } from "../../common/GetCurrentUser"

const NationalityComponent = (props: any) => {
  const [t] = useTranslation("global")
  const user = parsedUser()
  return (
    <CRUD
      cssClass="modalRight"
      isModal={true}
      showModal={props.show}
      toggleCRUD={props.toggle}
      filterOpen={true}
      title={t("Nationality") ?? ""}
      getRecordsMethod="post"
      getRecordsPath={`nationality/list`}
      addEditRecordPath={`nationality/AddEdit`}
      deleteRecordPath="nationality/Delete"
      fieldsList={[
        {
          name: "name",
          title: t("name"),
        },
      ]}
      fields={[
        {
          name: "id",
          htmlType: "hidden",
          dbType: "string",
        },
        {
          name: "name",
          htmlType: "text",
          dbType: "string",
          title: t("name") ?? "",
          containerClass: "col-12 col-md-6",
          required: true,
        },
      ]}
      filterFields={[
        {
          name: "search",
          title: t("name") ?? "",
          htmlType: "text",
          dbType: "string",
          containerClass: "col-12 col-md-4",
        },
      ]}
    />
  )
}

export default NationalityComponent
